import {FormattedMessage} from "react-intl";
import RadioButtonGroup from "../../RadioButtonGroup/RadioButtonGroup";
import React from "react";
import RadioButtonGroup2 from "../../RadioButtonGroup/RadioButtonGroupimpedance/RadioButtonGroup2";
import {Link} from "react-router-dom";


let electroPolishing = [
    {
        id: 1,
        name: "electropolishing",
        checked: false,
        text: <FormattedMessage id="app.stencil-quotation.stencil-electropolishing-yes"
                                defaultMessage="Yes"
                                description=""/>
    },
    {
        id: 0,
        name: "electropolishing",
        checked: true,
        text: <FormattedMessage id="app.stencil-quotation.stencil-electropolishing-no"
                                defaultMessage="No"
                                description=""/>
    }
];

const Electropolishing = (props) => {

    let selectedEP = electroPolishing.map((item) => {
        item.checked = (item.id === props.selectedId);
        return item;
    });

    return (
        <div className="row">
            <div className="col-md-12 no-padding">
                <div className="stencil-details-div">
                    <div className="col-md-3 text-right stencil-content-item-heading">
                        <FormattedMessage id="app.stencil-quotation.stencil-electropolishing"
                                          defaultMessage="Electropolishing"
                                          description=""
                        />
                        &nbsp; &nbsp;
                        {/*<Link id="pcbstnclElect-qLink" to="/help/elect_polish" className="glyphicon glyphicon-question-sign question-link"></Link>*/}
                    </div>
                    <div className="btn-group col-md-9 stencil-details-div-items">
                        <RadioButtonGroup2 data={selectedEP} getParams={props.setStencilParams}/>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Electropolishing;



// WEBPACK FOOTER //
// ./src/components/Site/QuotationForm/StencilQuotationForm/StencilQuotationFormFields/Electropolishing.js